import { render, staticRenderFns } from "./KYCSettingsComplete.vue?vue&type=template&id=0271d428&scoped=true&"
import script from "./KYCSettingsComplete.vue?vue&type=script&lang=js&"
export * from "./KYCSettingsComplete.vue?vue&type=script&lang=js&"
import style0 from "./KYCSettingsComplete.vue?vue&type=style&index=0&id=0271d428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0271d428",
  null
  
)

export default component.exports